<template>
  <div class="seomain">
    <st-header
      title="出库"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
           
						<st-form-item key="purchasingtracking" label="物流公司" prop="purchasingtracking">
							<st-select
								v-model="formData['purchasingtracking']"
								name="物流商"
								placeholder="请选择物流商"
								:options="$option['getExpress']"
							>
							</st-select>
						</st-form-item>
						
						<st-form-item key="logisticsnumber" label="运单号" prop="logisticsnumber">
							 <van-field
								class="st-form-item-input"
								v-model="formData.logisticsnumber"
								name="运单号"
								label=""
								placeholder="请填写运单号"
							 />
						</st-form-item>
						
          </van-cell-group>
					
					<div class="st-form-title" style="margin-top: 20px;">产品信息</div>
					
					<div class="st-form-group">
					  <van-cell-group inset>
					    <div class="product-item" v-for="(v, k) in formData['items']" :key="k">
					      <div class="prudcut-del-box" v-if="formData['items'].length > 1" @click="delItem(k)"><i class="el-icon-close"></i></div>
					      <h3 style="text-align: center;">产品{{ k + 1 }}</h3>
								
					      <p style="margin-top: 20px;">SKU: {{ v.sku }}</p>
								<p style="margin-top: 20px;">产品名称: {{ v.pname }}</p>
								<p style="margin-top: 20px;">转仓数量: {{ v.quantity }}</p>
								<p style="margin-top: 20px;">已出库数量: {{ v.outstocknum }}</p>
								<p style="margin-top: 20px;">待出库数量: {{ v.quantity - v.outstocknum }}</p>
					
					      <st-form-item label="出库数量" :prop="`items.${k}.outnum`" :required="true">
					        <van-field
					          class="st-form-item-input"
					          v-model="formData['items'][k]['outnum']"
					          name="出库数量"
					          label=""
					          placeholder="请输入出库数量"
					        />
					      </st-form-item>
								
								<st-form-item :key="`items.${k}.inventorylog_id`" :prop="`items.${k}.inventorylog_id`" label="入库流水" :required="true">
									<st-select
										v-model="formData['items'][k]['inventorylog_id']"
										name="入库流水"
										placeholder="请选择入库流水"
										:options="$option['getInventoryLog']"
										:custom-params="{'inventory_id': formData['items'][k]['inventory_id']}"
									>
									</st-select>
								</st-form-item>
					
					    </div>
					    
					  </van-cell-group>
					</div>
					
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				purchasingtracking: '',
				logisticsnumber: '',
				items: [],
			}, 
      loading: false,
      actField: '',
      actOptions: [],
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
	computed: {
		 inAmount: function() {
			 return this.formData.in_amount = this.formData.exchange_rate * this.formData.out_amount;
			}
	},
  mounted() {},

  methods: {
    init() {
			let query = this.$route.query;
			if (query.id) this.formData.id = query.id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.transferEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					this.$set(this.formData, ['items'], data.items);
				}).catch((err) => {
					window.history.go(-1);
					console.log('exchange/edit', err);
				});
			} else {
				this.$post(this.$api.stGetRates + "USD", {}).then((res) => {
					this.formData.exchange_rate = res.data;
				});
				
				this.$post(`${this.$api.stIncomeOrderGeneCode}`, {}).then((res) => {
					this.$set(this.formData, ['code'], res.data)
				});
			}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			if (this.formData.id) {
				this.outgoods(formData);
			} else {
				
			}
      
    },
		
		outgoods(formData) {
			this.$post(this.$api.transferChange, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '出库异常');
			  } else {
			    this.$toast.success("出库成功");
			    this.$router.replace(`/transfern/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
		
		.product-item {
		  background-color: rgba(230, 236, 241, 1);
		  padding: 15px;
		  margin-top: 18px;
		
		  .prudcut-del-box {
		    margin-top: -10px;
		    float: right;
		    text-align: right;
		    font-size: 31px;
		    color: rgba(227, 60, 100, 1);
		  }
		}
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
